module.exports = __webpack_public_path__ + "static/media/ArrowTop.ded8203b.svg";